'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pricingLevel = require('./pricing-level');

var _pricingLevel2 = _interopRequireDefault(_pricingLevel);

var _couponDisplay = require('./coupon-display');

var _couponDisplay2 = _interopRequireDefault(_couponDisplay);

var _corporatePricingLevel = require('./corporate-pricing-level');

var _corporatePricingLevel2 = _interopRequireDefault(_corporatePricingLevel);

var _toggle = require('common/components/toggle');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PricingArea = _react2['default'].createClass({
    displayName: 'PricingArea',


    propTypes: {
        'signupUrl': _react2['default'].PropTypes.string,
        'pricingSource': _react2['default'].PropTypes.string,
        'paymentForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
        'signupForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
        'mustContactSales': _react2['default'].PropTypes.bool,
        'corpsLevelName': _react2['default'].PropTypes.string
    },

    getInitialState: function getInitialState() {
        return {
            'timePeriod': this.props.selectedTimePeriod ? this.props.selectedTimePeriod : this.props.timePeriodChoices[1].value
        };
    },

    onSelection: function onSelection(selection) {
        this.setState({
            'timePeriod': selection
        });
    },

    componentDidMount: function componentDidMount() {
        if (this.props.mustContactSales) {
            $('#contactUsButton').click();
        }
    },

    render: function render() {

        var plans = this.props.pricingData.billing_plans;
        var isAnnual = this.state.timePeriod == 'Y';
        var isMonthly = this.state.timePeriod == 'M';
        var coupon = this.props.coupon ? true : false;
        if (coupon) {
            if (isMonthly && this.props.coupon.monthly_rate == 0 || isAnnual && this.props.coupon.annual_rate == 0) {
                coupon = false;
            }
        }

        var levelCount = this.props.pricingData.billing_plans.length;
        var levels = plans.map(function (level, i) {
            if (level && level.name && level.is_displayed == 'true') {
                return _jsx(_pricingLevel2['default'], {
                    name: level.name,
                    monthlyPrice: level.monthly_price,
                    annualPrice: (level.annual_price / 12).toFixed(0),
                    monthlyCouponPrice: level.coupon_monthly_price && level.coupon_monthly_price.toFixed(0),
                    annualCouponPrice: level.coupon_annual_price && (level.coupon_annual_price / 12).toFixed(0),
                    price: isMonthly ? level.monthly_price : (level.annual_price / 12).toFixed(0),
                    couponPrice: isMonthly ? level.coupon_monthly_price && level.coupon_monthly_price.toFixed(0) : level.coupon_annual_price && (level.coupon_annual_price / 12).toFixed(0),
                    monthlyExpectedRate: level.monthly_expected_rate,
                    annualExpectedRate: level.annual_expected_rate,
                    monthlyProratedRate: level.monthly_prorated_rate,
                    annualProratedRate: level.annual_prorated_rate,
                    timePeriod: this.state.timePeriod,
                    maxSeats: level.max_seats,
                    mostPopular: level.is_api && i == 1,
                    coupon: coupon,
                    couponCode: coupon ? level.coupon_code : null,
                    isFreeTrialEligible: level.is_free_trial_eligible,
                    numFreeDays: level.num_free_days,
                    isTrialing: level.is_trialing,
                    proratio: level.proratio,
                    planId: level.plan_id,
                    isDisplayed: level.is_displayed,
                    googleOpenIdUrlAnnual: level.google_open_id_url_annual,
                    googleOpenIdUrlMonthly: level.google_open_id_url_monthly,
                    ccSuffix: level.cc_suffix,
                    ccExpiration: level.cc_expiration,
                    isCurrentPlan: level.current_plan == level.plan_id,
                    ApiPendingCancel: level.api_pending_cancel,
                    UiPendingCancel: level.ui_pending_cancel,
                    currentMonthlyRate: level.current_monthly_rate,
                    currentAnnualRate: level.current_annual_rate,
                    isLoggedIn: level.is_logged_in,
                    acctModalError: level.acct_modal_error,
                    wasSelectedBeforeLogIn: level.is_logged_in && level.was_selected_before_login,
                    isApi: level.is_api,
                    isEventbrite: this.props.pricingSource === 'eventbrite',
                    mainFeature: level.main_feature,
                    features: level.features,
                    totalColumns: levelCount,
                    signupUrl: this.props.signupUrl,
                    cardHolderName: this.props.cardHolderName,
                    paymentForm: this.props.paymentForm,
                    signupForm: this.props.signupForm,
                    mustContactSales: this.props.mustContactSales,
                    isUpgrade: level.is_upgrade,
                    isAdmin: this.props.isAdmin,
                    isDelinquent: this.props.isDelinquent
                }, i);
            }
        }.bind(this));

        var couponDisplay;
        if (coupon) {
            couponDisplay = _jsx(_couponDisplay2['default'], {
                couponCode: this.props.coupon.coupon_code,
                couponDescription: this.props.coupon.description
            });
        }

        var toggle;
        if (this.props.timePeriodChoices.length > 1) {
            toggle = _jsx(_toggle.Toggle, {
                choices: this.props.timePeriodChoices,
                initialSelection: this.props.selectedTimePeriod,
                onSelection: this.onSelection
            });
        }

        var errors;
        if (this.props.errors) {
            var errorMsg = 'Sorry, we could not process your payment.';
            if (this.props.errors['payment[submit]']) {
                errorMsg += ' ' + this.props.errors['payment[submit]'];
            }
            if (this.props.errors['payment[cc_number]']) {
                errorMsg += ' ' + this.props.errors['payment[cc_number]'];
            }
            if (this.props.errors['payment[0]']) {
                errorMsg += ' ' + this.props.errors['payment[0]'];
            }
            errors = _jsx('div', {
                className: 'row text-center l-padding-v-20'
            }, void 0, _jsx('p', {
                className: 'c-red'
            }, void 0, errorMsg));
        }

        return _jsx('div', {}, void 0, _jsx('div', {
            className: 'row'
        }, void 0, couponDisplay, toggle), errors, _jsx('div', {
            className: 'row levels l-padding-v-60 text-center'
        }, void 0, levels, _jsx(_corporatePricingLevel2['default'], {
            isApi: this.props.isApi,
            pricingSource: this.props.pricingSource,
            coupon: this.props.coupon,
            corporateFeatures: this.props.corporateFeatures,
            timePeriod: this.state.timePeriod,
            totalColumns: levelCount,
            corpLevelName: this.props.corpLevelName
        }, 'corporate')));
    }
});

module.exports = PricingArea;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/index.jsx
 ** module id = 780
 ** module chunks = 0
 **/